<app-menu></app-menu>

<div style="background-color: #ffffff;">
    <!-- Hero Section -->
    <div class="fundo-servicos uk-light">
        <div class="uk-container uk-text-center">
            <h1 class="hero-standard-title" uk-scrollspy="cls: uk-animation-slide-top-small; delay: 100">Desenvolvimento</h1>
            <p class="uk-text-large" style="opacity: 0.9;" uk-scrollspy="cls: uk-animation-slide-bottom-small; delay: 300">Soluções integradas e inovadoras para impulsionar o seu negócio.
            </p>
        </div>
    </div>
</div>

<!-- Desenvolvimento Section -->
<div class="white-section">
    <div class="uk-container">
        <div class="uk-text-center uk-margin-large-bottom" uk-scrollspy="cls: uk-animation-slide-top-small; delay: 100">
            <span class="category-title">Nossos Serviços</span>
            <h2 class="uk-text-bold">Criando Experiências Digitais</h2>
            <p class="uk-text-large" style="color: #64748b;">Do conceito ao lançamento, construímos soluções sob medida.
            </p>
        </div>

        <div class="uk-grid uk-grid-small uk-grid-match uk-child-width-1-4@l uk-child-width-1-2@m uk-child-width-1-1@s" uk-grid uk-scrollspy="cls: uk-animation-slide-bottom-small; target: > div; delay: 150">
            <!-- Websites -->
            <div>
                <div class="service-card service-card-compact">
                    <div class="service-icon-box small-icon"><i class="fa-solid fa-earth-americas" style="font-size: 1.5rem;"></i></div>
                    <h4 class="uk-text-bold">Websites</h4>
                    <p class="uk-text-small">Websites modernos, responsivos e otimizados para SEO que representam a sua marca de forma profissional.</p>
                </div>
            </div>
            <!-- Apps -->
            <div>
                <div class="service-card service-card-compact">
                    <div class="service-icon-box small-icon"><i class="fa-solid fa-mobile-screen-button" style="font-size: 1.5rem;"></i></div>
                    <h4 class="uk-text-bold">Apps Móveis</h4>
                    <p class="uk-text-small">Apps nativos e híbridos para Android e iOS com foco em performance e experiência do utilizador.</p>
                </div>
            </div>
            <!-- E-Commerce -->
            <div>
                <div class="service-card service-card-compact">
                    <div class="service-icon-box small-icon"><i class="fa-solid fa-cart-shopping" style="font-size: 1.5rem;"></i></div>
                    <h4 class="uk-text-bold">E-Commerce</h4>
                    <p class="uk-text-small">Lojas virtuais completas integradas com gateways de pagamento e gestão de produtos.</p>
                </div>
            </div>
            <!-- Sistemas de Gestão -->
            <div>
                <div class="service-card service-card-compact">
                    <div class="service-icon-box small-icon"><i class="fa-solid fa-laptop-code" style="font-size: 1.5rem;"></i></div>
                    <h4 class="uk-text-bold">ERP / CRM / LMS</h4>
                    <p class="uk-text-small">Sistemas de gestão personalizados para controlo de processos, equipes e operações diárias.</p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Integrations & APIs Section -->
<div class="muted-section" style="padding-bottom: 0;">
    <div class="uk-container">
        <div class="integration-highlight uk-light" uk-scrollspy="cls: uk-animation-scale-up; delay: 100">
            <div class="uk-grid uk-flex-middle uk-padding-large" uk-grid>
                <div class="uk-width-1-2@m">
                    <span class="category-title" style="color: #ef5350;">Integrações & Conectividade</span>
                    <h2 class="uk-heading-small uk-text-bold">Sistemas que trabalham juntos</h2>
                    <p class="uk-text-large" style="opacity: 0.8;">
                        Implementamos sistemas integrados que conectam diversos setores e departamentos da sua empresa,
                        garantindo um fluxo de informações contínuo e eficiente.
                    </p>
                </div>
                <div class="uk-width-1-2@m">
                    <div class="integration-card">
                        <div class="service-icon-box" style="background: rgba(255,255,255,0.1); color: white;"><i class="fa-solid fa-link" style="font-size: 1.8rem;"></i></div>
                        <h3 class="uk-text-bold">APIs Customizadas</h3>
                        <p style="opacity: 0.8;">
                            Desenvolvemos e integramos APIs que permitem que diferentes sistemas e plataformas se
                            comuniquem de forma eficiente. Com APIs bem estruturadas, sua empresa pode expandir suas
                            capacidades tecnológicas e otimizar processos complexos.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Consultoria Section -->
<div class="white-section">
    <div class="uk-container">
        <div class="uk-text-center uk-margin-large-bottom" uk-scrollspy="cls: uk-animation-slide-top-small; delay: 100">
            <span class="category-title">Consultoria & Segurança</span>
            <h2 class="uk-text-bold">Expertise Técnica para seu Negócio</h2>
            <p class="uk-text-large" style="color: #64748b;">Protegendo seu patrimônio digital e capacitando sua equipe.
            </p>
        </div>

        <div class="uk-grid uk-grid-match uk-grid-small uk-child-width-1-3@l uk-child-width-1-2@m uk-child-width-1-1@s"
            uk-grid uk-scrollspy="cls: uk-animation-slide-bottom-small; target: > div; delay: 150">
            <!-- Auditoria -->
            <div>
                <div class="service-card service-card-compact">
                    <div class="service-icon-box small-icon"><i class="fa-solid fa-magnifying-glass" style="font-size: 1.5rem;"></i></div>
                    <h4 class="uk-text-bold">Auditoria de Segurança</h4>
                    <p class="uk-text-small">
                        Avaliamos infraestrutura e código para identificar vulnerabilidades e propor melhorias críticas.
                    </p>
                </div>
            </div>
            <!-- Automação -->
            <div>
                <div class="service-card service-card-compact">
                    <div class="service-icon-box small-icon"><i class="fa-solid fa-gear" style="font-size: 1.5rem;"></i></div>
                    <h4 class="uk-text-bold">Automação de Segurança</h4>
                    <p class="uk-text-small">
                        Implementamos ferramentas de automação para monitoramento contínuo e testes em tempo real.
                    </p>
                </div>
            </div>
            <!-- Treinamento -->
            <div>
                <div class="service-card service-card-compact">
                    <div class="service-icon-box small-icon"><i class="fa-solid fa-graduation-cap" style="font-size: 1.5rem;"></i></div>
                    <h4 class="uk-text-bold">Treinamento e Capacitação</h4>
                    <p class="uk-text-small">
                        Workshops para capacitar sua equipe com as melhores práticas de segurança e desenvolvimento.
                    </p>
                </div>
            </div>
            <!-- Gestão de Risco -->
            <div>
                <div class="service-card service-card-compact">
                    <div class="service-icon-box small-icon"><i class="fa-solid fa-triangle-exclamation" style="font-size: 1.5rem;"></i></div>
                    <h4 class="uk-text-bold">Gestão de Risco</h4>
                    <p class="uk-text-small">
                        Mitigamos riscos promovendo uma cultura resiliente e segura dentro da sua organização.
                    </p>
                </div>
            </div>
            <!-- Compliance -->
            <div>
                <div class="service-card service-card-compact">
                    <div class="service-icon-box small-icon"><i class="fa-solid fa-file-shield" style="font-size: 1.5rem;"></i></div>
                    <h4 class="uk-text-bold">Consultoria em Compliance</h4>
                    <p class="uk-text-small">
                        Garantimos que sua empresa esteja em conformidade com as regulamentações e padrões de segurança.
                    </p>
                </div>
            </div>
            <!-- Continuidade de Negócio -->
            <div>
                <div class="service-card service-card-compact">
                    <div class="service-icon-box small-icon"><i class="fa-solid fa-clock-rotate-left" style="font-size: 1.5rem;"></i></div>
                    <h4 class="uk-text-bold">Continuidade de Negócio</h4>
                    <p class="uk-text-small">
                        Estratégias de backup e recuperação de desastres para garantir que sua operação nunca pare.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Formulário de Contato Section -->
<div class="muted-section">
    <div class="uk-container">
        <div class="uk-text-center uk-margin-large-bottom" uk-scrollspy="cls: uk-animation-slide-top-small; delay: 100">
            <span class="category-title">Entre em Contato</span>
            <h2 class="uk-text-bold">Vamos Conversar?</h2>
            <p class="uk-text-large" style="color: #64748b;">Estamos prontos para transformar suas ideias em realidade.
            </p>
        </div>

        <div class="contact-form-wrapper" uk-scrollspy="cls: uk-animation-slide-bottom-small; delay: 200">
            <div class="contact-form-card">
                <form id="contactForm" class="uk-form-stacked">
                    <!-- Campos Básicos -->
                    <div class="uk-grid uk-grid-small uk-child-width-1-2@m" uk-grid>
                        <div>
                            <label class="uk-form-label" for="nome">Nome *</label>
                            <div class="uk-form-controls">
                                <input class="uk-input" id="nome" name="nome" type="text" placeholder="Seu nome completo" required>
                            </div>
                        </div>
                        <div>
                            <label class="uk-form-label" for="email">Email *</label>
                            <div class="uk-form-controls">
                                <input class="uk-input" id="email" name="email" type="email" placeholder="seu@email.com" required>
                            </div>
                        </div>
                    </div>

                    <div class="uk-margin-top">
                        <label class="uk-form-label" for="telefone">Telefone *</label>
                        <div class="uk-form-controls">
                            <input class="uk-input" id="telefone" name="telefone" type="tel" placeholder="+244 900 000 000" required>
                        </div>
                    </div>

                    <!-- Tipo de Mensagem -->
                    <div class="uk-margin-top">
                        <label class="uk-form-label">Tipo de Mensagem *</label>
                        <div class="uk-form-controls">
                            <div class="uk-grid uk-grid-small uk-child-width-1-2@s" uk-grid>
                                <div>
                                    <label class="message-type-radio">
                                        <input class="uk-radio" type="radio" name="tipoMensagem" value="comercial" checked>
                                        <span class="radio-label">Comercial</span>
                                    </label>
                                </div>
                                <div>
                                    <label class="message-type-radio">
                                        <input class="uk-radio" type="radio" name="tipoMensagem" value="tecnica">
                                        <span class="radio-label">Técnica</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Campos Comerciais -->
                    <div id="camposComerciais" class="dynamic-fields">
                        <div class="uk-margin-top">
                            <label class="uk-form-label" for="mensagemComercial">Mensagem *</label>
                            <div class="uk-form-controls">
                                <textarea class="uk-textarea" id="mensagemComercial" name="mensagemComercial" rows="4" placeholder="Descreva sua necessidade comercial..."></textarea>
                            </div>
                        </div>
                        <div class="uk-margin-top">
                            <label class="uk-form-label" for="urlComercial">URLs de Anexos (Opcional)</label>
                            <div class="uk-form-controls">
                                <textarea class="uk-textarea" id="urlComercial" name="urlComercial" rows="3" placeholder="Cole as URLs dos arquivos, uma por linha...
Ex: https://drive.google.com/file/d/...
Ex: https://dropbox.com/s/..."></textarea>
                            </div>
                        </div>
                    </div>

                    <div id="camposTecnicos" class="dynamic-fields" style="display: none;">
                        <div class="uk-margin-top">
                            <label class="uk-form-label" for="produto">Produto ou Serviço *</label>
                            <div class="uk-form-controls">
                                <select class="uk-select" id="produto" name="produto">
                                    <option value="" disabled selected>Selecione uma opção</option>
                                    <option value="Hospedagem">Hospedagem</option>
                                    <option value="Nuvem Privada">Nuvem Privada</option>
                                    <option value="Registro de dominio">Registro de dominio</option>
                                    <option value="Email corporativo">Email corporativo</option>
                                    <option value="Desenvolvimento">Desenvolvimento</option>
                                </select>
                            </div>
                        </div>

                        <div class="uk-grid uk-grid-small uk-child-width-1-1" uk-grid>
                            <div class="uk-margin-top">
                                <label class="uk-form-label" for="mensagemTecnica">Mensagem *</label>
                                <div class="uk-form-controls">
                                    <textarea class="uk-textarea" id="mensagemTecnica" name="mensagemTecnica" rows="4" placeholder="Descreva sua necessidade técnica ou problema..."></textarea>
                                </div>
                            </div>
                            <div class="uk-margin-top">
                                <label class="uk-form-label" for="urlTecnico">URLs de Anexos (Opcional)</label>
                                <div class="uk-form-controls">
                                    <textarea class="uk-textarea" id="urlTecnico" name="urlTecnico" rows="3" placeholder="Cole as URLs dos arquivos, uma por linha...
Ex: https://drive.google.com/file/d/...
Ex: https://dropbox.com/s/..."></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Botão de Envio -->
                    <div class="uk-margin-top uk-text-center">
                        <button type="submit" class="submit-btn">
                            <i class="fa-solid fa-paper-plane"></i>
                            <span>Enviar Mensagem</span>
                        </button>
                    </div>

                    <!-- Mensagem de Sucesso -->
                    <div id="successMessage" class="uk-alert-success uk-alert" style="display: none;">
                        <a class="uk-alert-close" uk-close></a>
                        <p><i class="fa-solid fa-check-circle"></i> Mensagem enviada com sucesso! Entraremos em contato em breve.</p>
                    </div>

                    <!-- Mensagem de Erro -->
                    <div id="errorMessage" class="uk-alert-danger uk-alert" style="display: none;">
                        <a class="uk-alert-close" uk-close></a>
                        <p><i class="fa-solid fa-exclamation-circle"></i> Ocorreu um erro ao enviar a mensagem. Por favor, tente novamente.</p>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<app-rodape></app-rodape>

